import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    forceRejectReason: false,
    multipleRolesCombinedBehavior: "",
    loginToken: "",
    trinFormsUrl: "",
    loaded: false
  }
};
const systemSettingInfoSlice = createSlice({
  name: "systemSettingInfo",
  initialState,
  reducers: {
    getSystemSettings: (state, action) => {
      state.value = {
        forceRejectReason: action.payload.forceRejectReason,
        multipleRolesCombinedBehavior: action.payload.multipleRolesCombinedBehavior,
        loginToken: action.payload.loginToken,
        trinFormsUrl: action.payload.trinFormsUrl,
        loaded: true
      };
    }
  }
});
export const { getSystemSettings } = systemSettingInfoSlice.actions;
export default systemSettingInfoSlice.reducer;
